import { GetRequestOptions } from "./grunt";

const Pth=process.env.REACT_APP_GRUNT_API+"/reg";
const StatusOk={status:200};

const getAllMigracije=async({_pdf1=false,_pdf2=false,_xlsx=false,_knjige=[],_pasmine=[],_posjednici=[],_stanjenadan=undefined,_otislasgospodarstva=undefined,_doltipperiod=undefined,_doltipperiod_datod,_doltipperiod_datdo,_spol,_roddatod=undefined,_roddatdo=undefined,_doltipperiod_posjednik_knjiga=undefined,_odltipperiod_migracijeid=[],_doltipperiod_migracijeid=[],
    _doltipperiod_dtelj,_doltipperiod_dkup,_doltipperiod_duvoz,_doltipperiod_prijasnji_posjednik_knjiga,_odltipperiod_novi_posjednik_knjiga,_odltipperiod_posjednik_knjiga=undefined,_odltipperiod=undefined,_odltipperiod_datod,_odltipperiod_datdo,_odltipperiod_odltipids=[],_lokacije=[],_tovdaniod=undefined,_tovdanido=undefined,_tovdatod=undefined,_tovdatdo=undefined,_zivbr=undefined,_rfid=undefined,_oznput=undefined})=>{
    try {
        const _reqopt=GetRequestOptions("GET");
        let _pth=Pth;
        if (_pdf1) {
          _pth=_pth+"/pdf1";
        }
        if (_pdf2) {
          _pth=_pth+"/pdf2";
        }
        //******
        if (_xlsx) {
          _pth=_pth+"/xlsx";
        }
        //******
        //_reqopt.body=JSON.stringify({knjige:_knjige}) + posjednici;
        let _querystring="?knjige="+JSON.stringify(_knjige)+"&posjednici="+JSON.stringify(_posjednici);
        if (_stanjenadan!==undefined) {
            _querystring=_querystring+"&stanjenadan="+JSON.stringify(_stanjenadan);
        }
        
        if (_otislasgospodarstva!==undefined) {
            _querystring=_querystring+"&otislasgospodarstva="+JSON.stringify(true);
        }
        if (_doltipperiod  && _doltipperiod_migracijeid.length===0) {
            _querystring=_querystring+"&doltipperiod=true";
            _querystring=_querystring+"&doltipperiod_datod="+JSON.stringify(_doltipperiod_datod);
            _querystring=_querystring+"&doltipperiod_datdo="+JSON.stringify(_doltipperiod_datdo);
            _querystring=_querystring+"&doltipperiod_dtelj="+JSON.stringify(_doltipperiod_dtelj);
            _querystring=_querystring+"&doltipperiod_dkup="+JSON.stringify(_doltipperiod_dkup);
            _querystring=_querystring+"&doltipperiod_duvoz="+JSON.stringify(_doltipperiod_duvoz);
            if (_doltipperiod_posjednik_knjiga!==undefined && _doltipperiod_prijasnji_posjednik_knjiga!==-1) {
              _querystring=_querystring+"&doltipperiod_posjednik_knjiga="+_doltipperiod_posjednik_knjiga;
              _querystring=_querystring+"&doltipperiod_prijasnji_posjednik_knjiga="+_doltipperiod_prijasnji_posjednik_knjiga;
            }
            
        }
        if (_doltipperiod && _doltipperiod_migracijeid.length>0) {
            _querystring=_querystring+"&doltipperiod=true";
            _querystring=_querystring+"&doltipperiod_migracijeid="+JSON.stringify(_doltipperiod_migracijeid);
        }
        //odlazak po tipu i periodu
        if (_odltipperiod!==undefined && _odltipperiod_migracijeid.length===0) {
            _querystring=_querystring+"&odltipperiod=true";

            _querystring=_querystring+"&odltipperiod_datod="+JSON.stringify(_odltipperiod_datod);
            _querystring=_querystring+"&odltipperiod_datdo="+JSON.stringify(_odltipperiod_datdo);
            _querystring=_querystring+"&odltipperiod_odltipovi="+JSON.stringify(_odltipperiod_odltipids);
            if (_odltipperiod_posjednik_knjiga!==undefined && _odltipperiod_novi_posjednik_knjiga!==-1) {
              _querystring=_querystring+"&odltipperiod_posjednik_knjiga="+_odltipperiod_posjednik_knjiga;
              _querystring=_querystring+"&odltipperiod_novi_posjednik_knjiga="+_odltipperiod_novi_posjednik_knjiga;
            }
        }
        if (_odltipperiod!==undefined && _odltipperiod_migracijeid.length>0) {
          _querystring=_querystring+"&odltipperiod=true";
          _querystring=_querystring+"&odltipperiod_migracijeid="+JSON.stringify(_odltipperiod_migracijeid);
      }
        //filtriranje po lokacijama
        if (_lokacije!==undefined && _lokacije.length>0) {
            _querystring=_querystring+"&lokacije=" + JSON.stringify(_lokacije);
        }
        //pasmine
        if (_pasmine.length>0) {
          _querystring=_querystring+"&pasmine=" + JSON.stringify(_pasmine);
        }
        //tov
        if (_tovdaniod!==undefined && _tovdanido!==undefined) {
          _querystring=_querystring+"&tovdaniod=" + _tovdaniod+"&tovdanido="+_tovdanido;
        }
        //tov datumi
        if (_tovdatod!==undefined && _tovdatdo!==undefined) {
          _querystring=_querystring+"&tovdatod=" + _tovdatod+"&tovdatdo="+_tovdatdo;
        }
        //rod datumi
        if (_roddatod!==undefined && _roddatdo!==undefined) {
          _querystring=_querystring+"&roddatod=" + _roddatod+"&roddatdo="+_roddatdo;
        }
        //zivbr
        if (_zivbr!==undefined && _zivbr!=="") {
          _querystring=_querystring+"&zivbr=" + _zivbr;
        }
        //rfid
        if (_rfid!==undefined && _rfid!=="") {
          _querystring=_querystring+"&rfid=" + _rfid;
        }
        //oznput
        if (_oznput!==undefined && _oznput!=="" && !isNaN(_oznput)) {
          _querystring=_querystring+"&oznput=" + _oznput;
        }

        //spol
        if (_spol!==undefined && _spol!=="") {
          _querystring=_querystring+"&spol=" + _spol;  
        }
        
        const r = await fetch(_pth+_querystring, _reqopt);   
        let res;
        if (_pdf1 || _pdf2) {
          //res=await r.blob();
          res=await r.arrayBuffer();
          
        } else if (_xlsx) {
          res=await r.arrayBuffer();
        } else {
          res=await r.json();
        }
        
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
          throw new Error(r.statusText);                   
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}


const getRegistarPdf=async(godina,knjigaid)=>{
  try {
    const _reqopt=GetRequestOptions("GET");
    const _pth=Pth+`/rggpdf?godina=${godina}&knjigaid=${knjigaid}`;
    const r = await fetch(_pth, _reqopt);
    const res=await r.blob();

    if (r.status===200) {
      StatusOk.res=res;
      return StatusOk;
  } else {
    throw new Error(r.statusText);               
  }
        
  } catch (ex) {
    return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
  }
}

const getGodineRegistar=async()=>{
  try {
    const _reqopt=GetRequestOptions("GET");
    const _pth=Pth+"/godine";
    const r = await fetch(_pth, _reqopt);
    const res=await r.json();

    if (r.status===200) {
      StatusOk.res=res;
      return StatusOk;
  } else {
    throw new Error(r.statusText);               
  }
        
  } catch (ex) {
    return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
  }
}

export {getAllMigracije, getRegistarPdf,getGodineRegistar};

